import {
    Activity,
    ArrowRight,
    CheckCircle2,
    GitBranch,
    Newspaper,
    PhoneCall,
    Store,
    Users,
    Zap,
} from "lucide-react";
import { Link } from "react-router-dom";

const sections = [
    {
        title: "Actions du jour",
        description: "Traitez les franchises, les actualités et les signalements en attente.",
        icon: CheckCircle2,
        links: [
            { label: "Franchises", path: "/bo/franchises", icon: Store },
            { label: "Affectation en masse", path: "/bo/todo-franchise", icon: GitBranch },
            { label: "Validation des franchises", path: "/bo/franchise-review", icon: CheckCircle2 },
            { label: "Actualités à traiter", path: "/bo/news-articles", icon: Newspaper },
            { label: "Signalements", path: "/bo/signal-reports", icon: Activity },
        ],
    },
    {
        title: "Enrichissement",
        description: "Suivez les traitements et contrôlez les données enrichies.",
        icon: Zap,
        links: [
            { label: "KPI enrichissements", path: "/bo/enrichment-kpis", icon: Activity },
            { label: "Services", path: "/bo/services", icon: Activity },
            { label: "Qualification automatique", path: "/bo/auto-approve", icon: CheckCircle2 },
            { label: "Enrichissements validés", path: "/bo/enrichments/reviewed", icon: CheckCircle2 },
            { label: "Avancement des enrichissements", path: "/bo/enrichment-status", icon: Zap },
        ],
    },
    {
        title: "Établissements",
        description: "Accédez aux contrôles, aux sources légales et aux données de zone.",
        icon: Store,
        links: [
            { label: "Établissements à vérifier", path: "/bo/ghosts", icon: Store },
            { label: "Annonces légales", path: "/bo/boddac-history", icon: Newspaper },
            { label: "Couverture géographique", path: "/bo/zone", icon: GitBranch },
        ],
    },
    {
        title: "Terrain",
        description: "Retrouvez les outils de prospection et de suivi commercial.",
        icon: PhoneCall,
        links: [
            { label: "Campagne hebdomadaire", path: "/bo/weekly-mail", icon: Newspaper },
            { label: "Appels de prospection", path: "/bo-commercial", icon: PhoneCall },
        ],
    },
    {
        title: "Utilisateurs",
        description: "Les comptes de l'application et leur activité.",
        icon: Users,
        links: [
            { label: "Vue d'ensemble", path: "/bo/users", icon: Users },
            { label: "Activité des utilisateurs", path: "/bo/activity", icon: Activity },
        ],
    },
];

export default function BODashboard() {
    return (
        <div className="min-h-full bg-[#f5f7fb] px-5 py-10 md:px-10 md:py-14">
            <div className="mx-auto max-w-6xl">
                <header className="mb-9">
                    <p className="mb-2 text-xs font-semibold uppercase tracking-[0.16em] text-[#68738d]">
                        DuckFlow
                    </p>
                    <h1 className="text-3xl font-semibold tracking-tight text-[#17244a] md:text-4xl">
                        Bienvenue dans le back-office
                    </h1>
                    <p className="mt-2 max-w-2xl text-sm leading-6 text-[#68738d]">
                        Choisissez une activité pour accéder directement aux outils de l’équipe.
                    </p>
                </header>

                <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
                    {sections.map((section) => {
                        const SectionIcon = section.icon;

                        return (
                            <section
                                key={section.title}
                                className="flex flex-col rounded-2xl border border-[#e3e8f1] bg-white p-5 shadow-[0_2px_10px_rgba(20,32,64,0.04)]"
                            >
                                <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl bg-[#f1f4fa] text-[#273b6b]">
                                    <SectionIcon className="h-5 w-5" />
                                </div>
                                <h2 className="text-base font-semibold text-[#17244a]">{section.title}</h2>
                                <p className="mt-1 min-h-[60px] text-xs leading-5 text-[#68738d]">
                                    {section.description}
                                </p>
                                <nav aria-label={section.title} className="mt-3 space-y-1">
                                    {section.links.map(({ label, path, icon: Icon }) => (
                                        <Link
                                            key={path}
                                            to={path}
                                            className="group flex items-center gap-2 rounded-lg px-2 py-2 text-xs font-medium text-[#35415f] transition-colors hover:bg-[#f5f7fb] hover:text-[#17244a]"
                                        >
                                            <Icon className="h-4 w-4 shrink-0 text-[#7a849b]" />
                                            <span className="min-w-0 flex-1">{label}</span>
                                            <ArrowRight className="h-3.5 w-3.5 shrink-0 opacity-0 transition-opacity group-hover:opacity-100" />
                                        </Link>
                                    ))}
                                </nav>
                            </section>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
